import classNames from "classnames";
import { ButtonProps } from "./Button.types";
import styles from "./Button.module.css";

function Button(props: ButtonProps): JSX.Element {
  const {
    variant = "primary",
    width = "normal",
    disabled = false,
    type = "button",
    id = "general",
    onClick,
    children,
  } = props;

  const btnClassName = classNames({
    [styles.btn]: true,
    [styles.btnFull]: width === "full",
    [styles.btnLarge]: width === "large",
    [styles.btnMedium]: width === "medium",
    [styles.btnAuto]: width === "auto",
    [styles.primaryPrimaryTwo500]: variant === "primaryPrimaryTwo500",
    [styles.secondaryPrimaryTwo500]: variant === "secondaryPrimaryTwo500",
    [styles.primaryPrimaryOne500]: variant === "primaryPrimaryOne500",
    [styles.secondaryPrimaryOne500]: variant === "secondaryPrimaryOne500",
    [styles.primaryRed500]: variant === "primaryRed500",
    [styles.secondaryRed500]: variant === "secondaryRed500",
    [styles.primaryBlack500]: variant === "primaryBlack500",
    [styles.secondaryBlack500]: variant === "secondaryBlack500",
    [styles.primaryGreen500]: variant === "primaryGreen500",
    [styles.primaryBlue500]: variant === "primaryBlue500",
    [styles.secondaryBlue500]: variant === "secondaryBlue500",
    [styles.secondaryGreen500]: variant === "secondaryGreen500",
    [styles.primaryBlue800]: variant === "primaryBlue800",
    [styles.secondaryBlue800]: variant === "secondaryBlue800",
    [styles.landingPrimary]: variant === "landing-primary",
    [styles.landingPrimary2]: variant === "landing-primary2",
    [styles.landingSecondary]: variant === "landing-secondary",
    [styles.landingSecondary2]: variant === "landing-secondary2",
    [styles.saasPrimaryBlue]: variant === "saasPrimaryBlue",
    [styles.knowledgeBasePrimaryBlue]: variant === "knowledgeBasePrimaryBlue",
    [styles.knowledgeBaseSecondary]: variant === "knowledgeBaseSecondary",
    [styles.knowledgeBaseTabPrimary]: variant === "knowledgeBaseTabPrimary",
    [styles.knowledgeBaseTabSecondary]: variant === "knowledgeBaseTabSecondary",
    [styles.courseProgress]: variant === "courseProgress",
    [styles.courseNotStarted]: variant === "courseNotStarted",
    [styles.courseCompleted]: variant === "courseCompleted",
    [styles.courseBatchDelete]: variant === "courseBatchDelete",
    [styles.courseBatchDeleteActive]: variant === "courseBatchDeleteActive",
    [styles.zoomBtn]: variant === "zoomBtn",
    [styles.viewPicBtn]: variant === "viewPicBtn",
    [styles.disabledBtn]: disabled === true,
  });

  const handleOnClick = () => onClick;

  return (
    <button
      id={id}
      type={type}
      className={btnClassName}
      onClick={handleOnClick()}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default Button;
